import { Navigate, useLocation } from 'react-router-dom';

import { useGetUserProfileQuery } from '../../store/api/userApi';
import { isAuthenticated } from '../../utils/tokenManager';

interface SupportAdminRouteProps {
  children: React.ReactNode;
}

export function SupportAdminRoute({ children }: SupportAdminRouteProps) {
  const location = useLocation();
  const auth = isAuthenticated();
  
  const { data, isLoading } = useGetUserProfileQuery(undefined, {
    skip: !auth,
  });

  if (!auth) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-neutral-medium text-xl font-body animate-pulse">
            Loading...
          </p>
        </div>
      </div>
    );
  }

  const user = data?.data.user;
  const isSupportAdmin = user?.isAdmin || user?.role === 'admin_support';

  if (!isSupportAdmin) {
    // Redirect to home if not support admin or admin
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
